declare const $: any; // jQuery global

function validateEventForm(): void {
    let isValid = true;

    $("input[required], select[required]").each(function (this: any) {
        if (!$(this).val()) isValid = false;
    });

    $('input[id*="__Validated"]').each(function (this: any) {
        if ($(this).val()?.toString().toLowerCase() !== "true") isValid = false;
    });

    $("#event-booking-submit-btn button").prop("disabled", !isValid);
}

function associateValidationClicks(): void {
    // prevent stacking handlers
    $(".input-del-email")
        .off("blur")
        .on("blur", function (this: any) {
            const input = $(this);

            input.addClass("input-loading");
            input.removeClass("border-success border-2");

            const index = input.data("index");
            const email = input.val();

            if (!email) {
                input.removeClass("input-loading");
                validateEventForm();
                return;
            }

            const validationElem = $(`.validated-member-txt[data-index=${index}]`);
            validationElem.hide();

            const encodedEmail = encodeURIComponent(email);

            const eventId = $("#event-delegates").data("eventId") ?? "";
            const packageId = input.closest("form").find("#SelectedPackage").val() ?? "";

            $.ajax({
                method: "GET",
                url: `/umbraco/surface/eventbookingsurface/validatemembership?email=${encodedEmail}&delIndex=${index}&eventId=${eventId}&packageId=${packageId}`,
                async: true
            }).done(function (result: any) {
                input.removeClass("input-loading");

                if (!result || !result.valid) {
                    validationElem.html(`<b>${email}</b> ${result?.reason || "could not be added."}`);
                    validationElem.removeClass("text-success").addClass("text-red").show();

                    input.removeClass("border-success border-2").addClass("input-validation-error");
                    $(`#Delegates_${index}__Validated`).val("false");
                } else {
                    validationElem.html(`<b>${email}</b> can attend this event.`);
                    validationElem.removeClass("text-red").addClass("text-success").show();

                    input.removeClass("input-validation-error").addClass("border-success border-2");
                    $(`#Delegates_${index}__Validated`).val("true");
                }

                validateEventForm();
            });
        });

    $("input[required], select[required], .input-del-email")
        .off("change", validateEventForm)
        .on("change", validateEventForm);
}

function updateEventDelegates(form: any, quantity: number): void {
    const delegates = form.find("#event-delegates");
    const checkoutBtn = form.find("#event-booking-submit-btn");
    const delegateInfoHeader = form.find("#event-delegate-info-header");

    if (quantity === 0) {
        checkoutBtn.hide();
        delegateInfoHeader.hide();
        delegates.html("");
        return;
    }

    const rows = delegates.children(".delegate-form");
    const currentCount = rows.length;

    if (currentCount > quantity) {
        for (let i = currentCount - 1; i >= quantity; i--) {
            rows.eq(i).remove();
        }
    } else if (currentCount < quantity) {
        const temp = $("template#event-delegate-template")[0] as HTMLTemplateElement | undefined;
        if (!temp) {
            console.warn("No <template id='event-delegate-template'> found for delegate rows.");
        } else {
            for (let i = currentCount; i < quantity; i++) {
                const html = temp.innerHTML
                    .replace(/\{\{index\}\}/g, i.toString())
                    .replace(/\{\{delegate_title\}\}/g, `Delegate ${i + 1}`);
                delegates.append(html);
            }
        }
    }

    delegateInfoHeader.show();
    checkoutBtn.show();
}

export function initBookingPage(): void {
    $(document).on("change", "select.event-quantity", function (this: any) {
        const $this = $(this);
        const form = $this.parents("form");

        const quantity = parseInt(this.value, 10);
        const packageId = $this.data("package");

        form.find("#SelectedPackage").val(packageId);

        const quantityDropdowns = form.find(".ticket-section__table select.event-quantity");
        if (quantityDropdowns.length > 1) {
            quantityDropdowns.each((_: any, dd: any) => {
                dd.disabled = quantity > 0 && dd !== $this[0];
            });
        }

        updateEventDelegates(form, quantity);
        associateValidationClicks();
        validateEventForm();
    });

    // initial setup
    associateValidationClicks();
    validateEventForm();

    // Restore disabled state for package dropdowns when navigating back with a pre-selected package
    const allQuantityDropdowns = $(".ticket-section__table select.event-quantity");
    if (allQuantityDropdowns.length > 1) {
        let preSelectedDropdown: any = null;
        allQuantityDropdowns.each((_: any, dd: any) => {
            if ((parseInt($(dd).val(), 10) || 0) > 0) {
                preSelectedDropdown = dd;
            }
        });
        if (preSelectedDropdown) {
            allQuantityDropdowns.each((_: any, dd: any) => {
                dd.disabled = dd !== preSelectedDropdown;
            });
        }
    }

    // Restore visual validation state for delegates pre-filled from session
    $(".input-del-email").each(function(this: any) {
        const input = $(this);
        const index = input.data("index");
        const email = input.val();
        if (email && $(`#Delegates_${index}__Validated`).val()?.toString().toLowerCase() === "true") {
            input.addClass("border-success border-2");
            const msg = $(`.validated-member-txt[data-index=${index}]`);
            msg.html(`<b>${email}</b> can attend this event.`);
            msg.removeClass("text-red").addClass("text-success").show();
        }
    });
}